<template>
  <div>
    <v-flex xs12>
      <h2 class="text-center mb-3">Utflytting</h2>
    </v-flex>
    <v-flex xs12 class="mb-2">
      <BooleanInput v-model="stepValues.bool" @update-fields="updateFields"></BooleanInput>
    </v-flex>
    <v-flex xs12 class="mb-2" v-if="!stepValues.bool.moveToday.value == 1">
      <v-card flat>
        <v-card-text>
          <v-container fluid>
            <h4 class="mb-3 text-center">Flyttedato</h4>
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="stepValues.movingDate"
                  label="Velg dato"
                  prepend-icon="mdi-event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                locale="no"
                v-model="stepValues.movingDate"
                @input="menu2 = false"
                @change="updateFields"
              ></v-date-picker>
            </v-menu>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 class="mb-3">
      <v-textarea box v-model="stepValues.comment" @input="updateFields" label="Kommentar"></v-textarea>
    </v-flex>
    <StepButtons @next-page="next" @previous-page="previous" :step="this" />
  </div>
</template>

<script>
import step from "../../mixins/step";
export default {
  mixins: [step],
  data() {
    return {
      menu: false,
      menu2: false
    };
  },
  beforeMount: function() {
    this.stepValues.movingDate = new Date().toISOString().substr(0, 10)
  }
};
</script>
